import type { UseFormReturn } from 'react-hook-form';

import { FormDateInput, FormField, FormInput } from '@/_components';

import type { RevenueLockdownFormSchema } from './revenue-lockdown-form-schema';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<RevenueLockdownFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field: { value, onChange } }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Name"
            value={value ?? ''}
            onChange={onChange}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="lock_start_date"
        render={({ field: { value, onChange } }) => (
          <FormDateInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Lock Start Date"
            value={value}
            onValueChange={onChange}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="lock_end_date"
        render={({ field: { value, onChange } }) => (
          <FormDateInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Lock End Date"
            value={value}
            onValueChange={onChange}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
